import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "113",
  height: "45",
  viewBox: "0 0 113 45",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.79534 13.2045C9.71224 20.8097 37.0411 33.7114 53.5155 34.2668C82.2712 35.2361 94.6389 26.8818 105.221 20.866C107.34 19.6615 100.011 19.7409 97.5265 18.8527C90.7058 16.4144 101.716 18.1663 103.933 18.2755C105.963 18.3756 112.427 18.2676 110.855 21.3013C108.779 25.3078 104.901 29.044 101.54 32.2965",
      stroke: "#829AB1",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }